import auth from 'auth-client';

// TODO: Add actual error reporter
const reportError = () => {};

/**
 * Authenticated user
 *
 * @typedef {object} Auth
 * @property {string} accountId - Account ID
 * @property {string} userId - User ID
 * @property {string} jwt - JSON web token for API
 * @property {string} token - Firebase ID token
 */

/**
 * Verify logged in user or redirect back to login page. Note that the tokens
 * returned by the response are remapped to more commonly used terms.
 *
 * @return {Promise<Auth>} Promise holding logged in user
 */
export const login = async () => {
  const user = await auth.loginUser({ reportError, storeToken: true });
  const { accountId, userId, customToken: jwt, idToken: token } = user;
  return { accountId, userId, jwt, token };
};

/**
 * Logout user
 *
 * @return {void}
 */
export const logout = () => {
  auth.logoutUser({ reportError });
};
